import i18n from '../../i18n/config';
import type { ErrorMessageMap } from '../FormInput/types';

export type PhoneErrorMessageMap = ErrorMessageMap & {
  missingCountryError: string;
  genericError: string;
  invalidNumberError: string;
};

export const getPhoneErrorMessageMap = (): PhoneErrorMessageMap => ({
  patternMismatch: i18n.t('auth.pleaseEnterAValidPhoneNumber'),
  valueMissing: i18n.t('auth.phoneIsRequired'),
  missingCountryError: i18n.t('auth.pleaseSelectYourCountry'),
  genericError: i18n.t('auth.inputIsInvalid'),
  invalidNumberError: i18n.t('auth.pleaseEnterAValidPhoneNumber'),
});
